class FilterForm {
    constructor(el, opts={
        submitHandler: $.noop,
    }) {

        if (!el) {
            console.error('Filter class constructor requires "el" argument!');
            return;
        }

        

        const submitHandler = _.debounce(opts.submitHandler, 700);

        let $filterForm = $(el);
        this.$filterForm = $filterForm;

        if ( !$filterForm.hasClass("FilterForm-pantry") && !$filterForm.hasClass("flatlist") ) {
            restoreFormState($filterForm, "serebricaFilterFormState");
        }

        if (!$filterForm.length) {
            console.error('FilterForm constructor can\'t find given "el" in DOM!');
            return;
        }


        let multicheckboxes = [];
        $filterForm.find(".Multycheckbox").each((index, el) => {
            multicheckboxes.push(new Multicheckbox(el));
        });

        let rangeSliders = [];
        $filterForm.find(".RangeSlider").each((index, el)=> {
            rangeSliders.push(
                new RangeSlider(el)
            );
        });

        let $inputs = $($filterForm.get(0).elements);

        $inputs.on('change', (event) => {
            event.preventDefault();
            $filterForm.trigger('submit');
        });

        $filterForm.on('submit', (event) => {
            event.preventDefault();
            submitHandler($filterForm);
            saveFormState($filterForm, "serebricaFilterFormState");
            this.saveStateToURL();
            return false;
        }).trigger('submit');


        $(".FiltersOpts_resetBtn").on('click', () => {
            this.resetFilterForm();
        });

        this.$filterForm = $filterForm;
        this.$inputs = $inputs;
        this.rangeSliders = rangeSliders;
        this.multicheckboxes = multicheckboxes;
    }

    saveStateToURL() {
        const formParams = new URLSearchParams(this.$filterForm.serialize().replace("&get_ids=", ""));
        const queryParams = new URLSearchParams(location.search);
        for (const param of formParams.keys()) {
            queryParams.set(param, formParams.get(param))
        }
        console.log(queryParams.toString())
        let newURL = location.pathname + '?' + queryParams.toString();
        history.replaceState({}, document.title, newURL);
    }

    resetFilterForm() {
        console.log('reset', this.$filterForm[0]);
        this.$filterForm.find('input:checkbox').removeAttr('checked');
        this.$filterForm[0].reset();
        this.rangeSliders.forEach((rangeSliderInst) => {
            rangeSliderInst.reset();
        });

        this.multicheckboxes.forEach((multiCheckboxInst) => {
            multiCheckboxInst.reset();
        });

    }

    getRangeSliders() {
        return this.rangeSliders;
    }

    /*save() {
        
    }

    restore() {
        
    }*/
}
